import { ActionState, ActionStateEnum, EditModeEnum, AddEntityState, EditEntityState } from "..";
import { EntityManager } from "../../plan/EntityManager";
import { PlanManager } from "../../../../cocosPlan";
import { Entity, Events, eventsManager, Listener, math, SceneConstants } from "@rhinov/savane-js";

/**
 * Created by rhinov15 on 27/05/2016.
 */



export class IdleCameraState extends ActionState {

    state: number = ActionStateEnum.idleCamera;
    previousGridState: number = PlanManager.getInstance().scrollWindow.grid._isGridVisible;
    planFloorChanged: Listener | null;
    cameraEditionListener: Listener | null;
    cameraAddListener: Listener | null;

    constructor() {
        super();
        
        //Hide grid
        PlanManager.getInstance().scrollWindow.grid._isGridVisible = false;
        if (PlanManager.getInstance().world.currentScene!.currentFloor!.walls.length > 0) {
            eventsManager.instance.dispatch(Events.HIDE_BACKGROUND_PRESSED, false);
        }
        this.planFloorChanged = eventsManager.instance.addListener(Events.PLAN_FLOOR_CHANGED, this.lockView.bind(this));
        //Add listener for camera edition change
        this.cameraEditionListener = new Listener((event: any) => {
            var newState = new EditEntityState(event.userData.entity, PlanManager.getInstance()._uiState.cursorPosition);
            eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
        });
        eventsManager.instance.addListenerObject(Events.ENTITY_EDITION, this.cameraEditionListener);
        this.cameraAddListener = new Listener((event: any) => {
            var newState = new AddEntityState(event.userData.entity, undefined);
            eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
        });
        eventsManager.instance.addListenerObject(Events.ENTITY_ADD, this.cameraAddListener);
    }

    getAction(): number {
        return this.state;
    }

    lockView() {
        //Lock grid movement to fit plan
        //PlanManager.getInstance().scrollWindow.centerPosition(true,false);
        //Change room node
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }
    lockViewNoOffset() {
        //Lock grid movement to fit plan
        //PlanManager.getInstance().scrollWindow.centerPosition(true,false);
        eventsManager.instance.dispatch(Events.HIDE_GRID_PRESSED, false);
        //Change room node
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }
    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3) {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._mouseDragging(posx, posy, true);
        return null;
    }
    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number) {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._endDragging(posx, posy, true);

        return null;
    }

    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        var planManager = PlanManager.getInstance();
        if (hoverEntities !== null && hoverEntities.length !== 0) {
            planManager.updateItemsSelected(hoverEntities, undefined, false);

            if (hoverEntities[0].entityType === SceneConstants.EntityType.UserPicture) {
                let node = EntityManager.getInstance().getNode(hoverEntities[0]);
                if (node && node.toRotate(cursorPosition)) {
                    return new EditEntityState(hoverEntities[0], cursorPosition, node.toRotate(cursorPosition), EditModeEnum.rotate);
                }
            }
        }
        else {
            var selectedEntities = planManager.selectedEntities.slice();

            if (selectedEntities.length === 1) {
                if (selectedEntities[0].entityType === SceneConstants.EntityType.UserPicture) {
                    let node = EntityManager.getInstance().getNode(selectedEntities[0]);
                    if (node && node.toRotate(cursorPosition)) {
                        return new EditEntityState(selectedEntities[0], cursorPosition, node.toRotate(cursorPosition), EditModeEnum.rotate);
                    }
                }
            }

            planManager.updateItemsSelected(null);
        }

        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        planManager.scrollWindow._startDragging(posx, posy, true);
        return null;
    }

    isDecorationState(): boolean {
        return (true);
    }

    dispose() {
        eventsManager.instance.removeListener(this.planFloorChanged!);
        eventsManager.instance.removeListener(this.cameraEditionListener!);
        eventsManager.instance.removeListener(this.cameraAddListener!);
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.endVisualiseMode();
            }
        }
    }
}

